// extracted by mini-css-extract-plugin
module.exports = {"legal":"Legal_legal__246fT","content":"Legal_content__3m_Yu"};